import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// API functions
export const analyzeText = async (ingredientsText, productName) => {
  const response = await api.post('/analyze/text', {
    ingredients_text: ingredientsText,
    product_name: productName || 'Unknown Product',
  });
  return response.data;
};

export const analyzeImage = async (imageBase64, productName = null) => {
  const response = await api.post('/analyze/image', {
    image_base64: imageBase64,
    product_name: productName,
  });
  return response.data;
};

export const analyzeBarcode = async (barcode, productName = null) => {
  const response = await api.post('/analyze/barcode', {
    barcode,
    product_name: productName,
  });
  return response.data;
};

export const getScanHistory = async () => {
  const response = await api.get('/user/history');
  return response.data;
};

export const searchProducts = async (query) => {
  const response = await api.get(`/products/search?q=${encodeURIComponent(query)}`);
  return response.data;
};

export const getCommunityReports = async (limit = 50) => {
  const response = await api.get(`/community/reports?limit=${limit}`);
  return response.data;
};

export const createCommunityReport = async (reportData) => {
  const response = await api.post('/community/report', reportData);
  return response.data;
};

export const upvoteReport = async (reportId) => {
  const response = await api.post(`/community/report/${reportId}/upvote`);
  return response.data;
};

// Contribute Product functions
export const contributeProduct = async (productData) => {
  const response = await api.post('/products/contribute', productData);
  return response.data;
};

export const checkBarcodeAvailability = async (barcode) => {
  const response = await api.get(`/products/barcode/${barcode}`);
  return response.data;
};

export const getContributedProducts = async (limit = 50) => {
  const response = await api.get(`/products/contributed?limit=${limit}`);
  return response.data;
};

export const getMyContributedProducts = async () => {
  const response = await api.get('/products/contributed/mine');
  return response.data;
};

export default api;
